// Six primary service categories — simplified presentation layer.
// Deep service content still lives in services.js (detail pages + SEO).
export const categories6 = [
  {
    id: "esg-strategy",
    num: "01",
    name: "ESG Strategy & Advisory",
    summary:
      "We help organisations define what ESG means for their business, focus on what matters and build a roadmap that holds up.",
    services: [
      { label: "ESG strategy", slug: null },
      { label: "Materiality", slug: "esg-risk" },
      { label: "ESG maturity", slug: null },
      { label: "ESG governance", slug: "esg-governance" },
      { label: "Sustainability roadmap", slug: null },
    ],
    cta: "Discuss Your ESG Challenge",
    ctaService: "ESG Strategy",
  },
  {
    id: "climate-carbon",
    num: "02",
    name: "Climate & Carbon",
    summary:
      "We help organisations understand, measure and manage their climate exposure.",
    services: [
      { label: "GHG Accounting", slug: "ghg-accounting" },
      { label: "Carbon Footprinting", slug: "ghg-accounting" },
      { label: "Climate Risk Assessment", slug: "climate-risk" },
      { label: "Transition Risk", slug: "climate-risk" },
      { label: "Physical Risk", slug: "climate-risk" },
      { label: "Decarbonisation Strategy", slug: "net-zero" },
      { label: "Net Zero Roadmaps", slug: "net-zero" },
    ],
    cta: "Discuss Your Climate Challenge",
    ctaService: "Climate Risk",
  },
  {
    id: "esg-reporting",
    num: "03",
    name: "ESG Reporting & Disclosure",
    summary:
      "Credible, well-evidenced disclosures — prepared once, defended everywhere.",
    services: [
      { label: "BRSR", slug: "brsr" },
      { label: "BRSR Core", slug: "brsr" },
      { label: "GRI", slug: "sustainability-reporting" },
      { label: "ISSB", slug: "sustainability-reporting" },
      { label: "Sustainability Reporting", slug: "sustainability-reporting" },
      { label: "Investor Disclosure", slug: "esg-investor-disclosure" },
    ],
    cta: "Discuss Your Reporting Requirement",
    ctaService: "BRSR",
  },
  {
    id: "esg-policies",
    num: "04",
    name: "ESG Policies & Governance",
    summary:
      "The written foundation of good governance — coherent policies and clear oversight structures.",
    services: [
      { label: "ESG Policies", slug: "esg-policy" },
      { label: "Sustainability Policies", slug: "esg-policy" },
      { label: "Climate Policies", slug: "esg-policy" },
      { label: "Human Rights", slug: "human-rights" },
      { label: "D&I", slug: "diversity-inclusion" },
      { label: "Responsible Investment", slug: "responsible-investment" },
    ],
    cta: "Build Your Policy Framework",
    ctaService: "ESG Policy",
  },
  {
    id: "nature-social",
    num: "05",
    name: "Nature, Biodiversity & Social",
    summary:
      "Understand your dependencies and impacts — on ecosystems, people and communities.",
    services: [
      { label: "Biodiversity", slug: "biodiversity" },
      { label: "Nature-related Risk", slug: "biodiversity" },
      { label: "Water", slug: "water-resources" },
      { label: "Social Impact", slug: "social-impact" },
      { label: "Human Rights", slug: "human-rights" },
      { label: "Diversity & Inclusion", slug: "diversity-inclusion" },
    ],
    cta: "Discuss Nature & Social Risk",
    ctaService: "Biodiversity",
  },
  {
    id: "investment-training",
    num: "06",
    name: "Responsible Investment & Training",
    summary:
      "ESG intelligence for capital, and capability building for the people who deploy it.",
    services: [
      { label: "ESG Due Diligence", slug: "responsible-investment" },
      { label: "ESG Integration", slug: "responsible-investment" },
      { label: "SFDR", slug: "responsible-investment" },
      { label: "PAI", slug: "responsible-investment" },
      { label: "DNSH", slug: "responsible-investment" },
      { label: "ESG Training", slug: "esg-training" },
    ],
    cta: "Discuss Investment ESG",
    ctaService: "Responsible Investment",
  },
];
